import type { GenerateTermsRequest } from '@/api/generated/schemas';
import { TermGenerationMode, TermSpanMode, TermRecurrenceMode } from '@/api/generated/schemas';

import { isoOf, type TermGenMode, type TermRecurrence, type TermSpan } from './termGenerator';

const MODE_TO_API: Record<TermGenMode, TermGenerationMode> = {
  recurrence: TermGenerationMode.Recurrence,
  calendar: TermGenerationMode.Calendar,
};

const SPAN_TO_API: Record<TermSpan, TermSpanMode> = {
  includeEnds: TermSpanMode.IncludeEnds,
  startsOnly: TermSpanMode.StartsOnly,
};

const RECURRENCE_TO_API: Record<TermRecurrence, TermRecurrenceMode> = {
  chain: TermRecurrenceMode.Chain,
  days: TermRecurrenceMode.Days,
  weeks: TermRecurrenceMode.Weeks,
};

/** Hodnoty dialogu, ze kterých se skládá tělo požadavku. */
export interface GenerateTermsValues {
  mode: TermGenMode;
  span: TermSpan;
  recurrence: TermRecurrence;
  /** ISO datum (YYYY-MM-DD); použito jen v režimu opakování. */
  from: string;
  to: string;
  everyDays: number;
  everyWeeks: number;
  daysOfWeek: number[];
  calendarStarts: Date[];
  nightsOverride: number | null;
  confirmedCount: number;
}

export function toGenerateTermsRequest(values: GenerateTermsValues): GenerateTermsRequest {
  return {
    mode: MODE_TO_API[values.mode],
    span: SPAN_TO_API[values.span],
    recurrence: RECURRENCE_TO_API[values.recurrence],
    from: values.mode === 'recurrence' ? values.from : null,
    to: values.mode === 'recurrence' ? values.to : null,
    everyDays: values.everyDays,
    everyWeeks: values.everyWeeks,
    daysOfWeek: values.daysOfWeek,
    calendarStarts: values.calendarStarts.map(isoOf),
    nightsOverride: values.nightsOverride,
    confirmedCount: values.confirmedCount,
  } satisfies GenerateTermsRequest;
}
